import React from 'react';
import * as _ from 'lodash';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Table from '../../../../../facturotopia/table/Table';
import ConceptoTraslados from './impuestos-concepto/ConceptoTraslados';
import ConceptoRetenciones from './impuestos-concepto/ConceptoRetenciones';
import DecimalForConceptos from '../../../support/impuestos/DecimalForConceptos';
import ConceptoBaseCalculator from '../../../support/impuestos/ConceptoBaseCalculator';

const ConceptosList = ({ data, onDelete, onEdit }) => {
  const handleEdit = (item) => {
    onEdit(item);
  };

  const handleDelete = (item) => {
    const newData = data.filter((value) => item.id !== value.id);

    onDelete(newData);
  };

  return (
    <Table
      columns={columns(handleEdit, handleDelete)}
      rowKey={'id'}
      data={data}
    ></Table>
  );
};

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={['far', 'edit']} />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={['fas', 'trash']} />
          </Button>
        </>
      );
    },
  },
  {
    align: 'center',
    key: 'Cantidad',
    title: 'Cantidad',
    dataIndex: 'Cantidad',
  },
  {
    align: 'center',
    key: 'ClaveUnidad',
    title: 'Unidad',
    dataIndex: 'ClaveUnidad',
    render: (item) => {
      return <span>{item.ClaveUnidad + (item.Unidad ? ` - ${item.Unidad}` : '')}</span>;
    },
  },
  {
    key: 'Descripcion',
    title: 'Descripción',
    dataIndex: 'Descripcion',
    render: (item) => {
      return (
        <>
          <span className="amount-summary">{item.Descripcion}</span>
          <br />

          {item.CuentaPredial?.length === 1 && (
            <>
              <br />
              <strong> {'Cuenta predial:'} </strong>
              {item.CuentaPredial[0].Numero}
            </>
          )}

          {item.CuentaPredial?.length > 1 && (
            <>
              <br />
              <strong>{'Cuentas prediales:'}</strong>
              {item.CuentaPredial.map((predial) => (
                <div key={predial.id}>
                  <span>{' - ' + predial.Numero}</span>
                </div>
              ))}
            </>
          )}
        </>
      );
    },
  },
  {
    align: 'right',
    key: 'ValorUnitario',
    title: 'V. Unitario',
    dataIndex: 'ValorUnitario',
    render: (item) => {
      const valorUnitario = DecimalForConceptos.make(item.ValorUnitario).toString();

      return <span>{valorUnitario}</span>;
    },
  },
  {
    align: 'right',
    key: 'Impuestos',
    title: 'Impuestos',
    dataIndex: 'Impuestos',
    render: (item) => {
      return (
        <>
          <ConceptoTraslados data={_.get(item, 'Impuestos.Traslados.Traslado')} />
          <ConceptoRetenciones data={_.get(item, 'Impuestos.Retenciones.Retencion')} />
        </>
      );
    },
  },
  {
    align: 'right',
    key: 'Importe',
    title: 'Importe',
    dataIndex: 'Importe',
    render: (item) => {
      const base = new ConceptoBaseCalculator(item).get();
      const total = DecimalForConceptos.make(base).toFixed();

      return (
        <span>
          {total}
          {parseFloat(item.Descuento || 0) > 0 && (
            <span>
              <br />
              <br />- {item.Descuento}
            </span>
          )}
        </span>
      );
    },
  },
];

export default ConceptosList;
